import { render } from "./TheTitle.vue?vue&type=template&id=7cd55528&scoped=true"
const script = {}

import "./TheTitle.vue?vue&type=style&index=0&id=7cd55528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd55528"]])

export default __exports__